<template>
<div :class="localLang == 'fr' ? 'pl-12 pr-8 mt-6' : 'pr-10 pl-7 mt-6'">
     <v-row>
          <v-col cols="12" lg="4" md="6" sm="12">
               <v-hover v-slot:default="{ hover }">
                    <v-card :elevation="hover ? 12 : 2" :class="{ 'on-hover': hover }" @click="openSettings(1)" color="#6480AE" height="180" dark>
                         <v-card-title class="headline">
                              <v-icon class="mx-auto" size="80">mdi-palette</v-icon>
                         </v-card-title>
                         <v-card-subtitle>
                              <h1 class="text-center mt-3">{{ $t('color') }}</h1>
                         </v-card-subtitle>
                    </v-card>
               </v-hover>
          </v-col>

          <v-col cols="12" lg="4" md="6" sm="12">
               <v-hover v-slot:default="{ hover }">
                    <v-card :elevation="hover ? 12 : 2" :class="{ 'on-hover': hover }" @click="openSettings(2)" color="#6480AE" height="180" dark>
                         <v-card-title class="headline">
                              <v-icon class="mx-auto" size="80">mdi-map-marker</v-icon>
                         </v-card-title>
                         <v-card-subtitle>
                              <h1 class="text-center mt-3" style="line-height: 27px;">{{ $t('location') }}</h1>
                         </v-card-subtitle>
                    </v-card>
               </v-hover>
          </v-col>

          <v-col cols="12" lg="4" md="6" sm="12">
               <v-hover v-slot:default="{ hover }">
                    <v-card :elevation="hover ? 12 : 2" :class="{ 'on-hover': hover }" @click="openSettings(3)" color="#6480AE" height="180" dark>
                         <v-card-title class="headline">
                              <v-icon class="mx-auto" size="80">mdi-code-not-equal-variant</v-icon>
                         </v-card-title>
                         <v-card-subtitle>
                              <h1 class="text-center mt-3">{{ $t('gestionVisibilit') }}</h1>
                         </v-card-subtitle>
                    </v-card>
               </v-hover>
          </v-col>

          <v-col cols="12" lg="4" md="6" sm="12">
               <v-hover v-slot:default="{ hover }">
                    <v-card :elevation="hover ? 12 : 2" :class="{ 'on-hover': hover }" @click="openSettings(4)" color="#6480AE" height="180" dark>
                         <v-card-title class="headline">
                              <v-icon class="mx-auto" size="80">mdi-information</v-icon>
                         </v-card-title>
                         <v-card-subtitle>
                              <h1 class="text-center mt-3">{{ $t('info') }}</h1>
                         </v-card-subtitle>
                    </v-card>
               </v-hover>
          </v-col>

          <v-col cols="12" lg="4" md="6" sm="12">
               <v-hover v-slot:default="{ hover }">
                    <v-card :elevation="hover ? 12 : 2" :class="{ 'on-hover': hover }" @click="openSettings(5)" color="#6480AE" height="180" dark>
                         <v-card-title class="headline">
                              <v-icon class="mx-auto" size="80">mdi-email</v-icon>
                         </v-card-title>
                         <v-card-subtitle>
                              <h1 class="text-center mt-3">{{ $t('email') }}</h1>
                         </v-card-subtitle>
                    </v-card>
               </v-hover>
          </v-col>

          <v-col cols="12" lg="4" md="6" sm="12">
               <v-hover v-slot:default="{ hover }">
                    <v-card :elevation="hover ? 12 : 2" :class="{ 'on-hover': hover }" @click="openSettings(6)" color="#6480AE" height="180" dark>
                         <v-card-title class="headline">
                              <v-icon class="mx-auto" size="80">mdi-image</v-icon>
                         </v-card-title>
                         <v-card-subtitle>
                              <h1 class="text-center mt-3" style="line-height: 27px;">{{ $t('logo') }}</h1>
                         </v-card-subtitle>
                    </v-card>
               </v-hover>
          </v-col>

     </v-row>

     <v-dialog v-model="dialog" persistent :max-width="id == 6 ? '400' : '600'">
          <v-card>
               <v-card-title class="headline py-2" style="background:#6480AE; color:#fff">
                    {{ $t(title) }}
                    <v-spacer></v-spacer>
                    <v-tooltip bottom>
                         <template v-slot:activator="{ on }">
                              <v-btn v-on="on" color="white" outlined icon @click="close" class="mt-1 mr-2">
                                   <v-icon>mdi-close</v-icon>
                              </v-btn>
                         </template>
                         <span>{{ $t('close') }}</span>
                    </v-tooltip>

               </v-card-title>
               <v-card-text class="py-0">
                    <div v-if="id == 1">
                         <v-row class="py-0">
                              <v-col cols="12" class="py-0">
                                   <v-radio-group v-model="form.color" column>
                                        <v-row v-for="(e,i) in colors" :key="i" class="pa-0">
                                             <v-col cols="1">
                                                  <v-radio :color="e.val" :value="e.color" :name="e.name"></v-radio>
                                             </v-col>
                                             <v-col cols="11">
                                                  <v-chip :color="e.color" style="width:500px"></v-chip>
                                             </v-col>
                                        </v-row>

                                   </v-radio-group>
                              </v-col>
                         </v-row>
                    </div>
                    <div v-else-if="id == 2">
                         <v-row class="mt-5">
                              <v-col cols="6">
                                   <v-text-field :label="$t('lng')" v-model="form.lang" dense hide-details outlined clearable></v-text-field>
                              </v-col>
                              <v-col cols="6">
                                   <v-text-field :label="$t('lat')" v-model="form.lat" dense hide-details outlined clearable></v-text-field>
                              </v-col>
                              <v-col cols="6">
                                   <v-autocomplete :items="wilaya" v-model="form.wilaya_id" clearable dense :label="$t('wilaya')" :item-text="localLang=='fr' ? 'name_fr' : 'name_ar'" item-value="id" outlined hide-details></v-autocomplete>
                              </v-col>
                              <v-col cols="6">
                                   <v-autocomplete :items="commune2" v-model="form.commune_id" clearable dense :label="$t('commune')" item-text="nom" item-value="id" outlined hide-details>
                                   </v-autocomplete>
                              </v-col>
                              <v-col cols="12" style="height:300px">
                                   <GmapMap :options="{
                                             zoomControl: true,
                                             mapTypeControl: true,
                                             scaleControl: true,
                                             streetViewControl: true,
                                             rotateControl: true,
                                             fullscreenControl: true,
                                             disableDefaultUi: true
                                        }" ref="mapRef" v-bind:center="center" :zoom="8" map-type-id="terrain" style="width: 100%; height: 100%">
                                        <GmapMarker :key="index" v-for="(m, index) in markers" :position="m.position" @drag="updateCoordinates" :clickable="true" :draggable="true" />
                                   </GmapMap>
                              </v-col>
                         </v-row>
                    </div>
                    <div class="mt-4" v-else-if="id == 3">
                         <v-tabs v-model="tab" centered style="background:#000">
                              <v-tab>{{ $t('navbar') }}</v-tab>
                              <v-tab>{{ $t('servises') }}</v-tab>
                         </v-tabs>

                         <v-tabs-items v-model="tab">
                              <v-tab-item>
                                   <v-row v-for="(e,i) in tools.data " :key="i">
                                        <v-col cols="12" lg="5" md="5" class="py-0" sm="12">
                                             <v-text-field class="py-0  mt-0" v-model="e.nameFr" hide-detail></v-text-field>
                                        </v-col>
                                        <v-col cols="12" lg="5" md="5" class="py-0" sm="11">
                                             <v-text-field class="py-0 mt-0" v-model="e.nameAr" hide-details></v-text-field>
                                        </v-col>
                                        <v-col cols="12" lg="1" md="1" sm="1">

                                             <v-tooltip bottom>
                                                  <template v-slot:activator="{ on }">
                                                       <v-checkbox class="py-0 mt-1" v-if="e.status == '0'" v-on="on" v-model="e.status" :value="1"></v-checkbox>
                                                       <v-checkbox class="py-0 mt-1" v-else v-on="on" v-model="e.status" :value="0"></v-checkbox>
                                                  </template>
                                                  <span>{{ $t('visible') }}</span>
                                             </v-tooltip>
                                        </v-col>
                                   </v-row>
                              </v-tab-item>
                              <v-tab-item>
                                   <div>
                                        <v-row  v-for="(e,i) in tools.data2" :key="i">
                                             <v-col cols="9">
                                                  <span :class="localLang == 'fr' ? 'float-left styleText' : 'float-right styleText' ">{{ $t(e.name) }}</span>
                                             </v-col>
                                             <v-col cols="2">
                                                  <v-tooltip bottom>
                                                       <template v-slot:activator="{ on }">  
                                                            <v-checkbox class="py-0 mt-1" v-if="e.status == '0'" v-on="on" v-model="e.status" :value="1"></v-checkbox>
                                                            <v-checkbox class="py-0 mt-1" v-else v-on="on" v-model="e.status" :value="0"></v-checkbox>
                                                       </template>
                                                       <span>{{ $t('visible') }}</span>
                                                  </v-tooltip>
                                             </v-col>
                                        </v-row>
                                   </div>
                              </v-tab-item>
                         </v-tabs-items>

                    </div>
                    <div v-else-if="id == 4" class="mt-5">
                         <v-tabs v-model="tab" centered style="background:#000">
                              <v-tab>{{ $t('general') }}</v-tab>
                              <v-tab>{{ $t('horaire') }}</v-tab>
                         </v-tabs>

                         <v-tabs-items v-model="tab">
                              <v-tab-item>
                                   <v-row>
                                        <v-col cols="12" lg="6" md="6" sm="12">
                                             <v-text-field class="py-0  mt-0" :label="$t('webname')" v-model="form.webname" hide-detail></v-text-field>
                                        </v-col>
                                        <v-col cols="12" lg="6" md="6" sm="12">
                                             <v-text-field class="py-0  mt-0" :label="$t('adress')" v-model="form.adresse" hide-detail></v-text-field>
                                        </v-col>
                                        <v-col cols="12" lg="6" md="6" sm="12">
                                             <v-text-field class="py-0  mt-0" :label="$t('phone')" v-model="form.telephone" hide-detail></v-text-field>
                                        </v-col>
                                        <v-col cols="12" lg="6" md="6" sm="12">
                                             <v-text-field class="py-0  mt-0" :label="$t('fax')" v-model="form.fax" hide-detail></v-text-field>
                                        </v-col>
                                        <v-col cols="12" lg="6" md="6" sm="12">
                                             <v-text-field class="py-0  mt-0" :label="$t('twetter')" v-model="form.twitter" hide-detail></v-text-field>
                                        </v-col>
                                        <v-col cols="12" lg="6" md="6" sm="12">
                                             <v-text-field class="py-0  mt-0" :label="$t('facebook')" v-model="form.facebook" hide-detail></v-text-field>
                                        </v-col>
                                   </v-row>
                              </v-tab-item>
                              <v-tab-item>
                                   <v-row>
                                        <v-col class="py-0 mt-4" cols="12" lg="3" md="3" sm="3">{{ $t('samedi') }}</v-col>
                                        <v-col class="py-0 my-0" cols="12" lg="9" md="9" sm="9">
                                             <v-text-field class="py-0  mt-0" v-model="form.datee.samedi" hide-detail></v-text-field>
                                        </v-col>

                                        <v-col class="py-0 mt-4" cols="12" lg="3" md="3" sm="3">{{ $t('dimanche') }}</v-col>
                                        <v-col class="py-0 my-0" cols="12" lg="9" md="9" sm="9">
                                             <v-text-field class="py-0  mt-0" v-model="form.datee.dimanche" hide-detail></v-text-field>
                                        </v-col>

                                        <v-col class="py-0 mt-4" cols="12" lg="3" md="3" sm="3">{{ $t('lundi') }}</v-col>
                                        <v-col class="py-0 my-0" cols="12" lg="9" md="9" sm="9">
                                             <v-text-field class="py-0  mt-0" v-model="form.datee.lundi" hide-detail></v-text-field>
                                        </v-col>

                                        <v-col class="py-0 mt-4" cols="12" lg="3" md="3" sm="3">{{ $t('mardi') }}</v-col>
                                        <v-col class="py-0 my-0" cols="12" lg="9" md="9" sm="9">
                                             <v-text-field class="py-0  mt-0" v-model="form.datee.mardi" hide-detail></v-text-field>
                                        </v-col>

                                        <v-col class="py-0 mt-4" cols="12" lg="3" md="3" sm="3">{{ $t('mercredi') }}</v-col>
                                        <v-col class="py-0 my-0" cols="12" lg="9" md="9" sm="9">
                                             <v-text-field class="py-0  mt-0" v-model="form.datee.mercredi" hide-detail></v-text-field>
                                        </v-col>

                                        <v-col class="py-0 mt-4" cols="12" lg="3" md="3" sm="3">{{ $t('jeudi') }}</v-col>
                                        <v-col class="py-0 my-0" cols="12" lg="9" md="9" sm="9">
                                             <v-text-field class="py-0  mt-0" v-model="form.datee.jeudi" hide-detail></v-text-field>
                                        </v-col>

                                        <v-col class="py-0 mt-4" cols="12" lg="3" md="3" sm="3">{{ $t('vendredi') }}</v-col>
                                        <v-col class="py-0 my-0" cols="12" lg="9" md="9" sm="9">
                                             <v-text-field class="py-0  mt-0" v-model="form.datee.vendredi" hide-detail></v-text-field>
                                        </v-col>

                                   </v-row>
                              </v-tab-item>
                         </v-tabs-items>
                    </div>
                    <div class="mt-4 text-center" style="line-height:30px" v-else-if="id == 5">
                         <h2 class="mb-12">{{ $t('msgChangeEmail') }}</h2>
                         <v-row>
                              <v-col cols="3" class="py-0  mt-0"></v-col>
                              <v-col class="py-0  mt-0" cols="6">
                                   <v-text-field class="py-0  mt-0" v-model="form.email" prepend-icon="mdi-email" hide-detail></v-text-field>
                              </v-col>
                              <v-col class="py-0  mt-0" cols="3"></v-col>
                              <v-col class="py-0  mt-0" cols="3"></v-col>
                              <!-- <v-col cols="6">
                                   <v-text-field class="py-0  mt-0" v-model="form.password_email" :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'" @click:append="show1 = !show1" prepend-icon="mdi-lock" :type="show1 ? 'text' : 'password'" hide-detail></v-text-field>
                              </v-col> -->
                              <v-col cols="3"></v-col>
                         </v-row>
                    </div>
                    <div v-else-if="id == 6">
                         <v-row>
                              <v-col height="50%" cols="12">
                                   <input type="file" style="border-radius: 50%;" ref="img2" hidden @change="selectImg">
                                   <v-card class="mx-auto " style="border-radius: 50%;  box-shadow: 0px 5px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 3px 5px 0px rgba(0, 0, 0, 0.12) !important;" @click="$refs.img2.click()" height="200" width="200">
                                        <v-avatar tile class="profil" height="100%" width="100%">
                                             <v-img v-if=" logo == ''" :src="'logo/' + ((settings[0] ? settings[0].logo : 'logo.png') || (settings[0].logo ? settings[0].logo : 'logo.png') ) | URL" max-height="100%" max-width="100%"></v-img>
                                             <v-img v-else :src="logo" max-height="100%" max-width="100%"></v-img>
                                             <!-- <v-img v-else-if="!settings[0].logo && logo ==''" :src="'logo/logo.png'| URL" max-height="100%" max-width="100%"></v-img> -->
                                        </v-avatar>
                                   </v-card>
                              </v-col>
                         </v-row>
                    </div>
               </v-card-text>
               <hr class="mt-3 mx-7">
               <v-card-actions class="py-0">
                    <v-spacer></v-spacer>
                    <v-btn v-if="!loading" color="green darken-1" class="mx-5 mb-3 mt-3" dark @click="saveChange">{{ $t('save') }}
                    </v-btn>
                    <span class="pa-2" color="success" v-else>{{ $t('patienter') }}</span>
               </v-card-actions>
          </v-card>
     </v-dialog>

</div>
</template>

<script>
export default {
     props: {
          allData: Object,
          heightP: Number,
          idApp: Number
     },
     data: () => ({
          tab: null,
          loading: false,
          show1: false,
          coordinates: null,
          center: {
               lat: 36.258265117286996,
               lng: 2.228445082902901
          },
          markers: [{
               position: {
                    lat: 36.258265117286996,
                    lng: 2.2286449074745107
               }
          }, ],
          ex7: 0,
          isBar: false,
          colors: [{
                    color: '#D2567C',
                    name: 'rz',
                    val: 'red darken-3'
               },
               {
                    color: '#3368C6',
                    name: 'bl',
                    val: 'indigo'
               },
               {
                    color: '#029F96',
                    name: 'gr',
                    val: 'success'
               },
               {
                    color: '#9C27B0',
                    name: 'mv',
                    val: 'purple'
               },
               {
                    color: '#2F839D',
                    name: 'mv',
                    val: '#2F839D'
               },
          ],
          height: 0,
          id: 1,
          title: '',
          logo: '',
          dialog: false,
          form: {},
          tools: {
               domainName: document.location.origin,
               data: {},
               data2: {},
          }
     }),

     methods: {
          updatePage() {

          },
          saveChange() {
               this.$store.dispatch('getMessage')
               this.$store.dispatch('getDemandes')
               if (this.isBar) {
                    var url = 'getBarItems/updatePage'
                    var commit = 'getBarItems'
                    this.loading = true
                    this.$Register({
                         data: JSON.stringify(this.tools)
                    }, url, commit).then((res) => {
                         this.$store.dispatch('getBarItems')
                         this.loading = false
                         this.dialog = false
                    }).catch((err) => {
                         this.loading = false
                    })
               } else {
                    var url = 'getSettings/saveSettings'
                    var commit = 'getSettings'

                    //   this.form.datee = this.form.datee
                    this.form.n_labo = localStorage.getItem('DSHUZDPSDSPDSJSU4')
                    this.loading = true
                    this.$Register({
                         data: JSON.stringify(this.form),
                         file: this.form.logo
                    }, url, commit).then((res) => {
                         this.loading = false
                         this.$store.dispatch('getSettings')
                         this.dialog = false
                    })
               }

          },
          selectImg() {
               const file = event.target.files[0]
               this.form.logo = file
               this.logo = URL.createObjectURL(file)
          },
          init() {
               this.form = {
                    color: '',
                    lang: '',
                    lat: '',
                    id: '',
                    telephone: '',
                    webname: '',
                    logo: '',
                    twitter: '',
                    facebook: '',
                    datee: {
                         samedi: '',
                         dimanche: '',
                         lundi: '',
                         mardi: '',
                         mercredi: '',
                         jeudi: '',
                         vendredi: '',
                    },
                    wilaya_id: '',
                    commune_id: '',
                    adresse: '',
                    fax: '',
                    email: '',
                    password_email: '',
                    domainName: document.location.origin,
                    n_labo: localStorage.getItem('DSHUZDPSDSPDSJSU4'),

               }
          },
          updateCoordinates(location) {
               this.coordinates = {
                    lat: location.latLng.lat(),
                    lng: location.latLng.lng(),
               }
               this.form.lang = this.coordinates.lng
               this.form.lat = this.coordinates.lat
          },
          changePosition(m) {
               this.center = m
          },
          openSettings(num) {
               this.$store.dispatch('getSettings')
               //        this.$store.dispatch('getBarItems')
               this.$store.dispatch('getItemBarNew')
               this.$store.dispatch('getMessage')
               this.$store.dispatch('getDemandes')
               this.tools.data = this.itemBarNew
               this.tools.data2 = this.status
               if (this.settings[0]) {
                    this.form = this.settings[0]
                    this.form.domainName = document.location.origin
                    this.markers[0].position.lng = parseFloat(this.settings[0].lang)
                    this.markers[0].position.lat = parseFloat(this.settings[0].lat)
                    this.form.datee = this.settings[0].datee ? JSON.parse(this.settings[0].datee) : {
                         samedi: '',
                         dimanche: '',
                         lundi: '',
                         mardi: '',
                         mercredi: '',
                         jeudi: '',
                         vendredi: '',
                    }
               }
               if (num == 1) {
                    this.title = 'color'
                    this.isBar = false
                    this.id = 1
                    this.dialog = true
               } else if (num == 2) {
                    this.title = 'location'
                    this.isBar = false
                    this.id = 2
                    this.dialog = true
               } else if (num == 3) {
                    this.title = 'gestionVisibilit'
                    this.isBar = true
                    this.id = 3
                    this.dialog = true
               } else if (num == 4) {
                    this.title = 'info'
                    this.isBar = false
                    this.id = 4
                    this.dialog = true
               } else if (num == 5) {
                    this.title = 'email'
                    this.isBar = false
                    this.id = 5
                    this.dialog = true
               } else if (num == 6) {
                    this.title = 'logo'
                    this.isBar = false
                    this.id = 6
                    this.dialog = true
               }
          },
          close() {
               this.dialog = false
          }
     },

     watch: {
          heightP(val) {
               this.height = val;
          },
     },
     computed: {
   
          settings() {
               return this.$store.state.settings
          },
          itemBarNew() {
               return this.$store.state.itemBarNew
          },
          commune2() {
               return this.$store.state.commune.filter(e => e.wilaya_id == this.form.wilaya_id)
          },
     },
     created() {
          this.init()
          this.$store.dispatch('getMessage')
          this.$store.dispatch('getDemandes')
          this.$store.dispatch('getStatus')
          Fire.$on("changHeight", e => {

               this.height = e;
          });

          if (this.settings[0]) {
               this.form = this.settings[0]
               this.form.domainName = document.location.origin
               this.markers[0].position.lng = parseFloat(this.settings[0].lang)
               this.markers[0].position.lat = parseFloat(this.settings[0].lat)
               this.form.datee = this.settings[0].datee ? JSON.parse(this.settings[0].datee) : {
                    samedi: '',
                    dimanche: '',
                    lundi: '',
                    mardi: '',
                    mercredi: '',
                    jeudi: '',
                    vendredi: '',
               }
          }
     }
}
</script>

<style scoped>
.styleText {
     font-size: 18px;
     font-weight: 900;
}

.theme--light.v-tabs-items {
     margin-top: 20px;
     margin-right: 30px;
     margin-left: 30px;
}

.theme--dark.v-tabs-items {
     margin-top: 20px;

}

.theme--light.v-tabs>.v-tabs-bar {

     background-color: #6480AE;
     color: #fff
}

.v-tabs:not(.v-tabs--vertical) .v-tab {
     white-space: normal;
     color: rgb(120, 248, 242);
     font-style: italic;
     font-weight: bold;
     background: #6480AE;

}

.theme--light.v-tabs>.v-tabs-bar .v-tab:not(.v-tab--active),
.theme--light.v-tabs>.v-tabs-bar .v-tab:not(.v-tab--active)>.v-icon,
.theme--light.v-tabs>.v-tabs-bar .v-tab:not(.v-tab--active)>.v-btn,
.theme--light.v-tabs>.v-tabs-bar .v-tab--disabled {
     color: #fff;

}
</style>
